<template>
    <section class="">
        <div class="container">
            <div class="row align-items-start mb-5">
                <div class="col-lg-6 mb-4 mb-lg-0 text-white text-start">
                    <h2 class="fw-bold text-white mb-3">Work with tools you already use</h2>
                    <p class="text-white mb-4">


                        Seamless access to agricultural data can transform food systems, eliminate hunger and poverty,
                        and support climate-smart practices. The Ghana Agricultural Data Hub (Ag-Data Hub) is being
                        developed as a secure, reliable platform for data sharing and informed decision-making to drive
                        policy and sustainable agriculture. </p>
                    <ul class="list-unstyled border-top pt-4">
                        <li v-for="(item, index) in items" :key="index" class="d-flex align-items-center mb-3 li-hover"
                            :class="{ 'text-warning': hoveredIndex === index }" @mouseover="hoveredIndex = index"
                            @mouseleave="hoveredIndex = null" @click="$router.push(item.route)" style="cursor: pointer">
                            <i class="me-2"
                                :class="{ 'text-warning bi bi-check-circle-fill link_icon': hoveredIndex === index, 'bi bi-check-circle text-white': hoveredIndex !== index }"></i>
                            <span class="ps-2 text-white"
                                :class="{ 'text-decoration-underline link_icon': hoveredIndex === index }">
                                {{ item.title }}
                            </span>
                        </li>
                    </ul>
                    <p class="text-white">
                        Deliver great service experiences fast - without the complexity of traditional ITSM solutions.
                    </p>
                </div>
                <div class="col-lg-6 d-flex  align-items-center" style="  height: 32rem;">
                    <div class="youtube-wrapper" @mouseover="playVideo" @mouseout="pauseVideo" @touchstart="playVideo"
                        @touchend="pauseVideo">
                        <h2 class="fw-bold text-white mb-3">From CSIR's Farm Acadamy</h2>
                        <div ref="player" class="youtube-player"></div>
                        <button class="btn view_btn rounded">View Courses</button>
                    </div>
                    <!-- <iframe class="vds-youtube" tabindex="-1" aria-hidden="true" data-no-controls="" frameborder="0" allow="autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope" src="https://www.youtube-nocookie.com/embed/aFfyEDll1-U?autoplay=0&amp;cc_lang_pref=en&amp;cc_load_policy=undefined&amp;color=red&amp;controls=0&amp;disablekb=1&amp;enablejsapi=1&amp;fs=1&amp;hl=en&amp;iv_load_policy=3&amp;mute=1&amp;playsinline=0"></iframe> -->
                    <!-- <iframe class="w-100" style="height: 4in;" src="https://www.youtube.com/embed/XGejMvXc9Ug"
                        title="Ghana’s Wheat Revolution: How CSIR-CRI and ARIMA Farms Are Leading the Charge"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
                    <!-- <div class="row" data-masonry='{"percentPosition": true }'>
                        <div
                            v-for="(item, index) in items"
                            :key="index"
                            class="col-6 mb-4"
                            @mouseover="hoveredIndex = index"
                            @mouseleave="hoveredIndex = null"
                        >
                            <Tooltip :text="item.description" :title="item.title" placement="bottom">
                                <router-link
                                    :to="item.route"
                                    class="card h-100 shadow-sm border-0 image-card text-decoration-none"
                                   
                                >
                                    <img
                                        :src="item.image"
                                        class="card-img-top img-fluid shadow-md"
                                        :alt="item.title"
                                    />
                                </router-link>
                            </Tooltip>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Masonry from "masonry-layout";
import Tooltip from "./tooltip.vue";

export default {
    name: "FeatureGridSection",
    components: {
        Tooltip,
    },
    data() {
        return {
            hoveredIndex: null,
            items: [
                {
                    image: require("../assets/services.png"),
                    title: "Services",
                    description: "Use our expert-built services tailored to your interests. These apps are powered by refined data found right here.",
                    route: "/main/services",
                },
                {
                    image: require("../assets/storyset.png"),
                    title: "Storyset",
                    description: "This summarizes a decade of analysis from the Africa RISING Dataverse, highlighting key findings and other crops relevant to our goals.",
                    route: "/main/storyset",
                },
                {
                    image: require("../assets/dashboard.png"),
                    title: "Dashboard",
                    description: "Select a dataset, choose the data fields you care about, and we’ll generate charts and graphs just for you. Not satisfied? Customize them your way and tell your own data story.",
                    route: "/main/dashboard",
                },
                {
                    image: require("../assets/datasets.png"),
                    title: "Datasets",
                    description: "Find the data you need for your projects on AgData-Hub. Explore, upload, and share datasets with the community—just sign up to get started.",
                    route: "/main/datasets",
                },
                {
                    image: require("../assets/croppingcalendar.png"),
                    title: "Cropping Calendar",
                    description: "The Cropping Calendar provides timely, data-driven guidance for planting and harvesting to boost yields.",
                    route: "/main/croppingcalendar",
                },
                {
                    image: require("../assets/wearther.png"),
                    title: "Weather",
                    description: "Weather Forecast Interface  offers real-time and future weather updates to help you plan and make informed farming decisions.",
                    route: "/weather",
                },
                {
                    image: require("../assets/extportal.png"),
                    title: "Extentions Portal",
                    description: "Our Extention Officers help manage Farmers Digitaly, The Ext. Portal helps them add, groups, send messges and also share information with farmers",
                    route: "/main/services",
                },
            ],
            player: null,
            videoId: "aFfyEDll1-U",
        };
    },
    mounted() {
        const container = this.$el.querySelector(".row[data-masonry]");
        if (container) {
            const images = container.querySelectorAll("img");
            let imagesLoaded = 0;

            images.forEach((img) => {
                if (img.complete) {
                    imagesLoaded++;
                    if (imagesLoaded === images.length) {
                        this.initMasonry(container);
                    }
                } else {
                    img.onload = () => {
                        imagesLoaded++;
                        if (imagesLoaded === images.length) {
                            this.initMasonry(container);
                        }
                    };
                }
            });
        }

        // Wait for API to load
        if (window.YT && window.YT.Player) {
            this.initPlayer();
        } else {
            window.onYouTubeIframeAPIReady = this.initPlayer;
        }
    },
    methods: {
        initMasonry(container) {
            new Masonry(container, {
                itemSelector: ".col-6",
                percentPosition: true,
            });
        },
        initPlayer() {
            this.player = new window.YT.Player(this.$refs.player, {
                height: "100%",
                width: "100%",
                videoId: this.videoId,
                playerVars: {
                    autoplay: 0,
                    controls: 0,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    mute: 0, // needed for autoplay to work on some browsers
                },
                events: {
                    onReady: (event) => {
                        event.target.pauseVideo();
                    },
                },
            });
        },
        playVideo() {
            if (this.player && this.player.playVideo) {
                this.player.playVideo();
            }
        },
        pauseVideo() {
            if (this.player && this.player.pauseVideo) {
                this.player.pauseVideo();
            }
        },
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
a,
li,
span,
div,
button,
input,
textarea,
select {
    font-family: "Montserrat", sans-serif;
    font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
}

.view_btn{
    background-color: green;
    color: white;
    font-weight: 500;
}

.view_btn:hover{
    background-color: rgb(205, 177, 0);
    color: white;
    font-weight: 500;
}

img {
    filter: brightness(0.8) saturate(1.2);
}

img:hover {
    filter: brightness(0.9);
}

.image-card {
    transition: transform 0.2s ease-in-out;
}

.image-card:hover {
    transform: scale(1.02);
    z-index: 2;
}

.text-decoration-underline {
    text-decoration: underline;
}

.link_icon {
    transform: scale(1.1);
    font-weight: 600;
    transition: transform 0.3s ease-in-out;
}

.li-hover:hover {
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
    transition: background-color 0.3s ease-in-out;
}


.youtube-wrapper {
  width: 100%;
  max-width: 800px;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 10px;
  margin: auto;
  cursor: pointer;
}
.youtube-player iframe {
  width: 100%;
  height: 100%;
}
</style>